<template>
  <section>
    <div class="popups">
      <b-sidebar
        v-model="showFilters"
        right
        shadow
        backdrop
        bg-variant="white"
        no-header
      >
        <template>
          <div class="container sidebar-header">
            <b-row>
              <div class="col">
                <b-button
                  variant="primary"
                  @click="
                    applyFilters();
                    loadItems();
                    showFilters = false;
                  "
                  >Apply</b-button
                >
              </div>

              <div class="col-auto text-right">
                <b-button
                  type="reset"
                  variant="outline-danger"
                  @click="resetFormFilters()"
                >
                  Reset
                </b-button>
                <b-button
                  variant="outline-secondary"
                  class="ml-1"
                  @click="
                    showFilters = false;
                    formFilters = { ...itemsFilters };
                  "
                >
                  Cancel
                </b-button>
              </div>
            </b-row>
          </div>

          <div class="px-3 py-2">
            <b-form-group label="Client:">
              <b-v-select
                v-model="formFilters.brandId"
                :searchable="true"
                :options="brandsFilter"
              />
            </b-form-group>
          </div>
        </template>
      </b-sidebar>
    </div>

    <div class="header">
      <div class="header-body">
        <div class="row align-items-end">
          <div class="col">
            <h1 class="header-title">
              Rate Shops
            </h1>
            <ActiveFiltersCard :itemsFilters="itemsFilters" :resetFilterWithKey="resetFilterWithKey" :loadItems="loadItems">
              <template v-slot:filterVal(projectId)="data">
                <span
                  v-if="myProjects && myProjects.find(a => a.id == data.item)"
                  >{{ myProjects.find(a => a.id == data.item).name }}</span
                >
                <span v-else>-</span>
              </template>
            </ActiveFiltersCard>
          </div>
          <div class="col-auto">
            <router-link
              :to="{ name: 'Manage.BrandRateShops.Create' }"
              class="btn btn-success mr-2"
              v-if="has('pm.other.storefrontRateShops.manage')"
            >
              <i class="mr-2 fa fa-plus" />
              Add New
            </router-link>
            <b-button variant="primary" @click="showFilters = !showFilters">
              <i class="fa fa-filter mr-2"></i>
              Filters
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <TableListing
      class="mb-0"
      :loading-page="loadingItems"
      :failed-loading="failedLoadItems"
      head-variant="dark"
      :items.sync="items"
      :fields.sync="fields"
      :pagination.sync="pagination"
      :options.sync="tableOptions"
      v-on:pagination-changed="loadItems"
    >
      <template v-slot:cell(brandId)="data">
        <span
          v-if="myBrands && myBrands.find(a => a.id == data.item.brandId)"
          >{{ myBrands.find(a => a.id == data.item.brandId).name }}</span
        >
        <span v-else>-</span>
      </template>
      <template v-slot:cell(mappingsCount)="data">
        <span>{{ data.item.mappings ? data.item.mappings.length : 0 }}</span>
      </template>
      <template v-slot:cell(createDateTimeUtc)="data">
        <span
          v-if="
            data.item.createDateTimeUtc &&
              !data.item.createDateTimeUtc.endsWith('Z')
          "
          >{{
            (data.item.createDateTimeUtc + 'Z') | moment('MMM Do YY, h:mm a')
          }}</span
        >
        <span v-else-if="data.item.createDateTimeUtc">{{
          data.item.createDateTimeUtc | moment('MMM Do YY, h:mm a')
        }}</span>
      </template>
      <template v-slot:cell(id)="data">
        <button
          type="button"
          class="btn btn-info ml-1"
          @click="EditItem(data.item)"
        >
          Edit
        </button>
      </template>
    </TableListing>
  </section>
</template>

<script>
import ActiveFiltersCard from '@/views/components/ActiveFiltersCard.vue';
import TableListing from '@/views/components/TableListing.vue';
import { crudMixinGen, myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
export default {
  name: 'Manage.BrandRateShops.Index',
  mixins: [crudMixinGen('storefrontRateShops'), myCommonDataMixin],
  components: {
    TableListing,
    ActiveFiltersCard
  },

  data: () => ({
    fields: [
      { key: 'brandId', label: 'Client', sortable: true },
      { key: 'name', label: 'Name', sortable: true },
      { key: 'filterByMaxDeliveryDays', label: 'Max Delivery Days', sortable: true },
      { key: 'mappingsCount', label: 'Mappings Count', sortable: false },
      { key: 'createDateTimeUtc', label: 'Created', sortable: true },
      { key: 'id', label: 'Action', sortable: false }
    ]
  }),

  mounted() {
    this.loadItems();
  },

  methods: {
    EditItem(item) {
      this.$router.push({
        name: 'Manage.BrandRateShops.Edit',
        params: { id: item.id }
      });
    }
  }
};
</script>